<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form" @submit.prevent="searchReports">
        <v-card tile outlined>
          <v-card-text>
            <div>
              1. 対象のサイト名を選択してください
              <v-chip color="pink" outlined label x-small> 必須 </v-chip>
            </div>
            <v-layout row>
              <v-select
                v-model="query.siteKeys"
                :items="selectableSites"
                item-text="name"
                item-value="siteKey"
                multiple
                class="ma-2"
                style="max-width: 500px"
                label="対象のサイト名を指定する"
                :rules="[() => this.query.siteKeys.length >= 1 || '必須入力項目です']"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="allSiteSelect"
                  >
                    <v-list-item-action>
                      <v-icon :color="query.siteKeys.length > 0 ? 'indigo darken-4' : ''">
                        {{ allSelectIcon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        全て選択
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-layout>
            <div>
              2. 検索期間を入力してください
              <v-chip color="pink" outlined label x-small> 必須 </v-chip>
            </div>
            <v-layout>
              <v-col cols="2">
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  :return-value.sync="query.startDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="query.startDate"
                      label="検索開始日"
                      prepend-icon="mdi-calendar"
                      required
                      :rules="[datesValidation]"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="query.startDate"
                    no-title
                    locale="jp-ja"
                    :day-format="(date) => new Date(date).getDate()"
                    style="height: 300px;"
                    @change="$refs.menuStartDate.save(query.startDate)"
                  />
                </v-menu>
              </v-col>
              〜
              <v-col cols="2">
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  :return-value.sync="query.endDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="query.endDate"
                      label="検索終了日"
                      prepend-icon="mdi-calendar"
                      required
                      :rules="[datesValidation]"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="query.endDate"
                    no-title
                    locale="jp-ja"
                    :day-format="(date) => new Date(date).getDate()"
                    style="height: 300px;"
                    @change="$refs.menuEndDate.save(query.endDate)"
                  />
                </v-menu>
              </v-col>
            </v-layout>
            <template v-if="isAdmin(currentUserAuth)">
              <div style="margin-top: 10px">
                2. ライター指定する場合は、ライター名を入力してください
              </div>
              <v-layout>
                <v-text-field
                  v-model="query.nameCont"
                  label="ユーザー名"
                  style="max-width: 200px"
                  clearable
                  class="ma-2"
                />
              </v-layout>
            </template>
            <v-layout>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                type="submit"
                @click="searchReports"
                @submit.prevent="searchReports"
              >
                検索
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  data: () => {
    return {
      query: {
        startDate: null,
        endDate: moment().format('YYYY-MM-DD'),
        nameCont: null,
        siteKeys: []
      },
      datesValidation: (value) => {
        if (!value) {
          return '必須入力項目です'
        } else {
          return true
        }
      },
      menuStartDate: false,
      menuEndDate: false
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites']),
    allSelectIcon () {
      if (this.query.siteKeys.length < this.selectableSites.length) return 'mdi-checkbox-blank-outline'
      if (this.query.siteKeys.length == this.selectableSites.length) return 'mdi-close-box'
    }
  },
  methods: {
    searchReports () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.$emit('search-reports', this.query)
      }
    },
    isAdmin (user) {
      return user.masterAccess == 'admin'
    },
    allSiteSelect () {
      if (this.query.siteKeys.length === this.selectableSites.length) {
        this.query.siteKeys.splice(0)
      } else {
        this.query.siteKeys = this.selectableSites.map(site => site.siteKey).slice()
      }
    }
  }
}
</script>

<style scoped lang="sass">
.layout
  display: flex
  align-items: center
.container--fluid
  margin-right: 40px
.v-data-table
  overflow-x: auto
  white-space: nowrap
</style>
